module.exports = __webpack_public_path__ + "static/pj-brown-resume-c29792a458d420abf51da5f720765d86.pdf";